import React, { useEffect, useState } from 'react';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import { makeStyles } from '@material-ui/core/styles';
import ExpandMore from '@material-ui/icons/ExpandMore';
import styles from 'assets/jss/material-dashboard-pro-react/views/numberDetails/servicesAccordionStyle';
import { HeadingS, HeadingSBold } from 'components/Typography/Typography';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import classNames from 'classnames';

// @ts-ignore
const useStyles = makeStyles(styles);

interface ICollapse {
	title: string;
	content?: React.ReactElement;
	notificationDot?: types.services.INotificationDot;
}

interface IServicesAccordionProps {
	// index of the default active collapse
	active?: number;
	collapses: ICollapse[];
}

const ServicesAccordion = ({ active = -1, collapses }: IServicesAccordionProps) => {
	const [activeCollapse, setActiveCollapse] = useState<number>(active);
	const classes = useStyles();

	const handleChange = (panel: any) => (event: any, expanded: boolean) => {
		setActiveCollapse(expanded ? panel : -1);
	};

	return (
		<div className={classes.root}>
			{collapses.map((prop, key) => {
				const { content, title, notificationDot } = prop;
				const collapse = !!content;
				return (
					<ExpansionPanel
						expanded={activeCollapse === key}
						onChange={handleChange(key)}
						key={key}
						classes={{
							root: classes.expansionPanel,
							expanded: classes.expansionPanelExpanded,
						}}
					>
						<ExpansionPanelSummary
							expandIcon={collapse && <ExpandMore />}
							classes={{
								root: classes.expansionPanelSummary,
								expanded: classes.expansionPanelSummaryExpanded,
								content: classes.expansionPanelSummaryContent,
								expandIcon: classes.expansionPanelSummaryExpandIcon,
							}}
						>
							<div className={classes.titleWrapper}>
								<ConditionalRender
									show={activeCollapse === key}
									onTrue={() => <HeadingSBold disableMargin>{title}</HeadingSBold>}
									onFalse={() => <HeadingS disableMargin>{title}</HeadingS>}
								/>
								<ConditionalRender
									show={!!notificationDot}
									onTrue={() => (
										<div
											className={classNames(classes.singleAccordionRowDot, {
												[classes[`${notificationDot?.color}SingleAccordionRowDot`]]:
													notificationDot?.color,
											})}
										/>
									)}
								/>
							</div>
						</ExpansionPanelSummary>
						<ConditionalRender
							show={!!prop.content}
							onTrue={() => (
								<ExpansionPanelDetails className={classes.expansionPanelDetails}>
									{prop.content}
								</ExpansionPanelDetails>
							)}
						/>
					</ExpansionPanel>
				);
			})}
		</div>
	);
};

export default ServicesAccordion;
